import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export type IntegrationStatus = {
  stripe: {
    configured: boolean;
    mode: 'test' | 'live' | null;
    webhook_signing_secret: boolean;
  };
  resend: {
    configured: boolean;
    mailer: string;
    from_address: string | null;
    from_name: string | null;
  };
  typesense: {
    configured: boolean;
    driver: string | null;
  };
  r2: {
    configured: boolean;
    disk: string | null;
    bucket: string | null;
  };
};

export function useIntegrationsStatus() {
  return useQuery({
    queryKey: ['settings', 'integrations'],
    queryFn: async (): Promise<IntegrationStatus> => {
      const { data } = await api.get<IntegrationStatus>('/v1/settings/integrations');
      return data;
    },
  });
}
